import { render, staticRenderFns } from "./VTextField.vue?vue&type=template&id=be3a7c88&scoped=true"
import script from "./VTextField.vue?vue&type=script&lang=js"
export * from "./VTextField.vue?vue&type=script&lang=js"
import style0 from "./VTextField.vue?vue&type=style&index=0&id=be3a7c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3a7c88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
